﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customDepartmentList from './tpl/customDepartmentList.html';
import View_CustomDepartmentListItem from './customDepartmentListItem';

export default Marionette.CollectionView.extend({
    childViewContainer: '#customDepartmentList',
    childView: View_CustomDepartmentListItem,
    getTemplate: function () {
        return tpl_customDepartmentList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});